import * as React from 'react';
import { useSelector } from 'react-redux';

import { PageHeader } from '../../components/PageHeader';
import { selectPageTitle } from '../../selectors/seoData';

export const PageHeaderContainer: React.FC = () => {
  const title = useSelector(selectPageTitle);

  return <PageHeader title={title} />;
};
